<template>
    <div class="page">
        <h1>This page is unavailable. Please return to the Home Page.</h1>
        <p>Click the link below</p>
        <a href="https://portfolio-46fc3.web.app/">Home Page</a>
        
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

a {
    font-size: 2rem;
}

p {
    text-decoration: underline;
}
</style>